import { Text } from 'platform-components';
import { TEXT_MARKUP_TYPE } from 'platform-components/constants';
import React from 'react';
import { connect } from 'react-redux';

import * as lessonViewSelectors from 'common.components/lesson-view.store/selectors';
import { getSubjectFromPath } from 'utils/path';

import AddProblemButton from '../__add-problem-button/lesson-view__add-problem-button';
import DeleteLessonButton from '../__delete-button/lesson-view__delete-button';

import './lesson-view__empty-state.scss';

interface StoreProps {
    canAddProblemToLesson: boolean;
}

interface Props extends StoreProps {}

export const EmptyState = ({ canAddProblemToLesson }: Props) => {
    if (canAddProblemToLesson) {
        return (
            <div className="lesson-view__empty-state">
                <div className="lesson-view__empty-state-description">
                    <Text id="lessonView.emptyState.addProblem" size={Text.SIZE.XL} type={TEXT_MARKUP_TYPE.MARKDOWN} />
                </div>
                <div className="lesson-view__empty-state-button">
                    <AddProblemButton />
                </div>
            </div>
        );
    }

    return (
        <div className="lesson-view__empty-state">
            <div className="lesson-view__empty-state-description">
                <Text id="lessonView.emptyState.deleteLesson" size={Text.SIZE.XL} type={TEXT_MARKUP_TYPE.MARKDOWN} />
            </div>
            <div className="lesson-view__empty-state-button">
                <DeleteLessonButton />
            </div>
        </div>
    );
};

const mapStateToProps = (storeState: any): StoreProps => {
    const subject = getSubjectFromPath();

    return {
        canAddProblemToLesson: lessonViewSelectors.getCanAddProblemToLesson(storeState, { subject }),
    };
};

export default connect(mapStateToProps)(EmptyState);
